"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _accordionWrapper = _interopRequireDefault(require("./accordion-wrapper"));

var _text = require("@mmc/text");

var _configuratorAccessoriesSelector = _interopRequireDefault(require("../styles/configurator-accessories-selector.css"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var renderPanelHeader = function renderPanelHeader(params) {
  var label = params.label,
      itemTotal = params.itemTotal,
      amountSelected = params.amountSelected,
      isExpanded = params.isExpanded,
      cardIndex = params.cardIndex,
      handleTriggerClick = params.handleTriggerClick,
      theme = params.theme;
  return /*#__PURE__*/_react["default"].createElement("h3", {
    className: "" + _configuratorAccessoriesSelector["default"].header
  }, /*#__PURE__*/_react["default"].createElement("button", {
    role: "tab",
    type: "button",
    onClick: handleTriggerClick,
    "aria-controls": "conf-card-panel-" + cardIndex,
    id: "conf-card-header-" + cardIndex,
    className: _configuratorAccessoriesSelector["default"].trigger + " " + theme.mmcIconChevronDown,
    "aria-expanded": isExpanded,
    "aria-selected": isExpanded
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: theme.inputsAndOptions + " " + _configuratorAccessoriesSelector["default"].fullWidth
  }, label, /*#__PURE__*/_react["default"].createElement("span", {
    className: _configuratorAccessoriesSelector["default"].accessoryAmount + " " + theme.smallType
  }, " (" + itemTotal + ")")), amountSelected > 0 && /*#__PURE__*/_react["default"].createElement("span", {
    className: _configuratorAccessoriesSelector["default"].selectedAmount + " " + theme.tags
  }, amountSelected)));
};

var renderPanelBody = function renderPanelBody(params) {
  var filteringOptions = params.filteringOptions,
      selectedAccessories = params.selectedAccessories,
      forcedOptionCodes = params.forcedOptionCodes,
      notCompatibleOptionCodes = params.notCompatibleOptionCodes,
      changeEvent = params.changeEvent,
      cardIndex = params.cardIndex,
      isExpanded = params.isExpanded,
      theme = params.theme,
      disclaimerData = params.disclaimerData,
      accessoriesPriceDisclaimerId = params.accessoriesPriceDisclaimerId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "conf-card-panel-" + cardIndex,
    "aria-hidden": !isExpanded,
    className: _configuratorAccessoriesSelector["default"].accordionDetails + " " + theme.row + " " + _configuratorAccessoriesSelector["default"].panel
  }, /*#__PURE__*/_react["default"].createElement(_accordionWrapper["default"], {
    filteringOptions: filteringOptions,
    changeEvent: changeEvent,
    selectedAccessories: selectedAccessories,
    forcedOptionCodes: forcedOptionCodes,
    notCompatibleOptionCodes: notCompatibleOptionCodes,
    theme: theme,
    disclaimerData: disclaimerData,
    accessoriesPriceDisclaimerId: accessoriesPriceDisclaimerId
  }));
};

var ExpandableCard = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ExpandableCard, _React$Component);

  function ExpandableCard(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = _this.getInitialState();
    _this.handleTriggerClick = _this.handleTriggerClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = ExpandableCard.prototype;

  _proto.getInitialState = function getInitialState() {
    var state = {
      isExpanded: false
    };
    var _this$props = this.props,
        hasRecommendedAccessories = _this$props.hasRecommendedAccessories,
        cardIndex = _this$props.cardIndex;

    if (!hasRecommendedAccessories && cardIndex === 0) {
      state.isExpanded = true;
    }

    return state;
  };

  _proto.handleTriggerClick = function handleTriggerClick(paneIndex) {
    this.togglePane(paneIndex);
  };

  _proto.togglePane = function togglePane() {
    var isExpanded = this.state.isExpanded; // eslint-disable-next-line react/no-access-state-in-setstate

    this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
      isExpanded: !isExpanded
    }));
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        theme = _this$props2.theme,
        filter = _this$props2.filter,
        selectedAccessories = _this$props2.selectedAccessories,
        forcedOptionCodes = _this$props2.forcedOptionCodes,
        notCompatibleOptionCodes = _this$props2.notCompatibleOptionCodes,
        changeEvent = _this$props2.changeEvent,
        cardIndex = _this$props2.cardIndex,
        disclaimerData = _this$props2.disclaimerData,
        accessoriesPriceDisclaimerId = _this$props2.accessoriesPriceDisclaimerId;
    var isExpanded = this.state.isExpanded;
    var filteringOptions = filter.filteringOptions || [];
    var label = filter.label || '';
    var amountSelected = 0;
    filteringOptions.forEach(function (option) {
      if (selectedAccessories.includes(option.code)) {
        amountSelected += 1;
      }
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _configuratorAccessoriesSelector["default"].accordionCard + " " + _configuratorAccessoriesSelector["default"].expandableCard + "  " + theme.accordion
    }, renderPanelHeader({
      label: label,
      itemTotal: filteringOptions.length,
      amountSelected: amountSelected,
      isExpanded: isExpanded,
      cardIndex: cardIndex,
      handleTriggerClick: this.handleTriggerClick,
      theme: theme
    }), renderPanelBody({
      filteringOptions: filteringOptions,
      selectedAccessories: selectedAccessories,
      forcedOptionCodes: forcedOptionCodes,
      notCompatibleOptionCodes: notCompatibleOptionCodes,
      changeEvent: changeEvent,
      cardIndex: cardIndex,
      isExpanded: isExpanded,
      theme: theme,
      disclaimerData: disclaimerData,
      accessoriesPriceDisclaimerId: accessoriesPriceDisclaimerId
    }));
  };

  return ExpandableCard;
}(_react["default"].Component);

exports["default"] = ExpandableCard;
ExpandableCard.displayName = 'ExpandableCard';
ExpandableCard.defaultProps = {
  theme: {}
};